var TexteDeroulant = {
	posX:0,
	maxX:0,
	init:function(){
		
		var _html = $(".texte-deroulant").html();
		TexteDeroulant.maxX = -1 * ($(".texte-deroulant .txt").outerWidth());
		for (var i = 0; i < 2; i++){
			$(".texte-deroulant").append(_html);
		}
		
		setTimeout(function(){
			$(".texte-deroulant").addClass("initialized");
		}, 200);
		
		setInterval(function(){
			TexteDeroulant.moveText();
		}, 10);
		
	},
	moveText:function(){
		if(TexteDeroulant.posX < TexteDeroulant.maxX){
			TexteDeroulant.posX = 0;
		}else{
			TexteDeroulant.posX -= 1;	
		}
		$(".texte-deroulant .txt").css({left:TexteDeroulant.posX})
	}
}

$(window).load(function(){
	if($(".texte-deroulant").length){
		TexteDeroulant.init();
	}
});